module.exports = __webpack_public_path__ + "img/order.6b829b3c.png";